import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import { ProjectModel } from 'api/dto/Project.dto';

import {
  DistributionMode,
  LifecycleSurveysDto,
  LifecycleSurveysModel,
  mapLifecycleSurveysDtoToModel,
} from './dto/LifecycleSurveys.dto';

export type LifecycleSurveySettings = {
  sendAtWeek: number | null;
  isActive: boolean;
  showOnReportDashboard: boolean;
};

export class PulseTemplateLifecycleSurveysApi {
  constructor(private apiClient: AxiosInstance) {}

  get(pulseTemplateId: ProjectModel['id']): Promise<LifecycleSurveysModel> {
    return this.apiClient
      .get<
        WithData<LifecycleSurveysDto>
      >(`/api/v1/pulse-template/${pulseTemplateId}/lifecycle-surveys`)
      .then(selectApiData)
      .then(mapLifecycleSurveysDtoToModel);
  }

  updateSettings(
    pulseTemplateId: ProjectModel['id'],
    projectId: number,
    settings: LifecycleSurveySettings,
  ): Promise<void> {
    return this.apiClient.put(
      `/api/v1/pulse-template/${pulseTemplateId}/lifecycle-survey/${projectId}/settings`,
      settings,
    );
  }

  updateDistributionMode(
    pulseTemplateId: ProjectModel['id'],
    distributionMode: DistributionMode,
  ): Promise<void> {
    return this.apiClient.put(
      `/api/v1/pulse-template/${pulseTemplateId}/lifecycle-flow/distribution-mode`,
      { distributionMode },
    );
  }
}
